<template>
    <v-card class="overflow-hidden">
        <BaseRemoteList
            ref="requestedUserList"
            :session-key="sessionKey"
            :maintitle="$t('requested_user')"
            :collection-class="RequestedUserCollection"
            :headers="headers"
            :extra-params="extraParams"
            :options="{ sortBy: ['username'] }"
            xlsx-export
            :height="height"
            :new-btn="false"
            @loading="loading = $event"
            @edit-item="editRecord"
            @dblclick:row="onRowDblClick"
        >
            <template #toolbar-items>
                |
                <v-btn-toggle v-model="toggleFilter" class="ml-2" borderless tile background-color="primary">
                    <IconBtn
                        value="just_unregistred"
                        color="primary"
                        :disabled="loading"
                        icon-cls="hourglass"
                        icon-color="white"
                        icon-disabled-color="grey"
                        :tooltip="$t('pendente_antraege')"
                    />
                    <IconBtn
                        value="unsent"
                        color="primary"
                        :disabled="loading"
                        icon-cls="editedafterpublication"
                        icon-color="white"
                        icon-disabled-color="grey"
                        :tooltip="$t('unversendete_informationen')"
                    />
                    <IconBtn
                        value="rejected"
                        color="primary"
                        :disabled="loading"
                        icon-cls="unlike"
                        icon-color="white"
                        icon-disabled-color="grey"
                        :tooltip="$t('zurueckgewiesene_anfragen')"
                    />
                </v-btn-toggle>
            </template>

            <template #item.created="{ item }">
                {{ item.created.formatIf('dd, DD.MM.YYYY HH:mm') }}
            </template>
            <template #item.is_generated="{ item }">
                <TrueFalseIcon :active="item.is_generated" />
            </template>
            <template #item.sent="{ item }">
                <TrueFalseIcon :active="item.sent" />
            </template>
            <template #item.rejected="{ item }">
                <TrueFalseIcon :active="item.rejected" />
            </template>
        </BaseRemoteList>
    </v-card>
</template>

<script>
import { RequestedUserCollection } from '@/models/RequestedUser';
import sessionStorageMixin from '@/mixins/session-storage';
import { getRoles } from '@/models/Role';

export default {
    name: 'RequestedUserIndex',
    components: {},
    mixins: [sessionStorageMixin],
    props: {
        sessionKey: {
            type: String,
            required: true,
        },
        height: {
            type: [String, Number],
            default: null,
        },
    },

    data() {
        return {
            loading: false,
            RequestedUserCollection,
            roles: getRoles(),
            headers: [
                { text: 'Aktionen', sortable: false, width: 80, value: 'actions' },
                { text: this.$t('firstname'), sortable: true, width: 100, value: '$.firstname' },
                { text: this.$t('lastname'), sortable: true, width: 100, value: '$.lastname' },
                { text: this.$t('title'), sortable: true, width: 200, value: '$.title' },
                { text: this.$t('email'), sortable: true, width: 200, value: '$.email' },
                { text: this.$t('created'), sortable: true, width: 100, value: 'created' },
                { text: this.$t('details'), sortable: true, width: 100, value: '$.details' },
                { text: this.$t('address'), sortable: true, width: 100, value: '$.address' },
                { text: this.$t('po_box'), sortable: true, width: 100, value: '$.po_box' },
                { text: this.$t('zip'), sortable: true, width: 100, value: '$.zip' },
                { text: this.$t('city'), sortable: true, width: 100, value: '$.city' },
                { text: this.$t('country'), sortable: true, width: 100, value: '$.country' },
                { text: this.$t('web'), sortable: true, width: 300, value: '$.web' },
                { text: this.$t('is_generated'), sortable: true, width: 120, value: 'is_generated' },
                { text: this.$t('sent'), sortable: true, width: 100, value: 'sent' },
                { text: this.$t('rejected'), sortable: true, width: 100, value: 'rejected' },
            ],
            toggleFilter: 'just_unregistred',
        };
    },

    computed: {
        extraParams() {
            const extraParams = {};
            if (this.toggleFilter) {
                extraParams[this.toggleFilter] = true;
            }
            return extraParams;
        },
    },

    methods: {
        onRowDblClick(e, data) {
            if (data.item) {
                this.editRecord(data.item);
            }
        },

        editRecord(requestedUser) {
            this.$router.push({ name: 'requested_user_edit', params: { id: requestedUser.id } });
        },
    },
};
</script>
